import { navigate } from "@my-dld/utils/StoreUtils";

export function navigateToSSOApp( url: string ) {
	if ( url.startsWith( "#" ) ) {
		navigate( url );
	} else if ( url.startsWith( "http://" ) || url.startsWith( "https://" ) ) {
		window.location.href = url;
	} else {
		const d = decodeURIComponent( url );
		if ( d.startsWith( "http://" ) || d.startsWith( "https://" ) ) {
			window.location.href = d;
		}
	}
}
